const general = {
  sites: 'Sites',
  site: 'Site',
  add_site: 'Nouveau Site',
  edit_site_access: "Modifier l'accès au site",
  search_site: 'Rechercher un site',
  delete_site_message: 'Etes-vous sûr que vous voulez supprimer {{site}}?',
  notifications: 'Notifications',
  notification: 'Notification',
  events: 'Evénements',
  site_info: 'Informations du site',
  add_notification: 'Nouvelle notification',
  send_to: 'Envoyer à',
  delete_contact_message:
    'Etes-vous sûr de vouloir supprimer le contact de notification {{contact}}?',
  invalid_email: "Format d'adresse courriel invalide",
  active_web_access: 'Accès web actif',
  no_web_access: 'Aucun accès web',
  select_unselect_all: 'Sélectionner/Désélectionner Tout',
  notification_at_least_one: 'Sélectionnez au moins une notification',
  table: {
    name: 'NOM',
    country: 'PAYS',
    city: 'VILLE',
    state: 'ÉTAT',
    timezone: 'FUSEAU HORAIRE',
  },
};

export default general;
